import { CreditCard, Apple, Smartphone, User } from "lucide-react";

const META = {
  stripe: {
    label: "Web (Stripe)",
    icon: CreditCard,
    classes: "bg-blue-500/15 text-blue-300 border-blue-400/20",
    dot: "bg-blue-400",
  },
  apple: {
    label: "App Store",
    icon: Apple,
    classes: "bg-slate-100/10 text-slate-200 border-slate-300/20",
    dot: "bg-slate-200",
  },
  google: {
    label: "Google Play",
    icon: Smartphone,
    classes: "bg-emerald-500/15 text-emerald-300 border-emerald-400/20",
    dot: "bg-emerald-400",
  },
  manual: {
    label: "Manuale",
    icon: User,
    classes: "bg-slate-600/20 text-slate-400 border-slate-500/20",
    dot: "bg-slate-500",
  },
};

/**
 * ProviderBadge — colored pill showing where the subscription was activated.
 * Accepts 'stripe' | 'apple' | 'google' | null (null → manuale).
 */
export const ProviderBadge = ({ provider, size = "default", className = "" }) => {
  const key = provider && META[provider] ? provider : "manual";
  const m = META[key];
  const Icon = m.icon;
  const sizing = size === "sm"
    ? "text-[10px] px-2 py-0.5 gap-1"
    : "text-xs px-2.5 py-1 gap-1.5";
  return (
    <span
      className={`inline-flex items-center font-semibold border rounded-full ${m.classes} ${sizing} ${className}`}
      data-testid={`provider-badge-${key}`}
    >
      <Icon className={size === "sm" ? "w-3 h-3" : "w-3.5 h-3.5"} />
      {m.label}
    </span>
  );
};
